<template>
  <div
    class="banner-container"
    v-if="list.length"
  >
    <div class="swiper-wrap">
      <div
        class="main-swiper"
        v-swiper="swiperOption"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(banner, index) in list"
            :key="index"
          >
            <img
              class="banner-item"
              :src="banner.url"
            >
          </div>
        </div>
      </div>
    </div>

    <div
      id="thumbs"
      ref="thumbs"
      v-swiper="thumbsSwiperOption"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          :class="{active: index === currentIndex}"
          v-for="(banner, index) in list"
          :key="index"
        >
          <img
            class="banner-item"
            :src="banner.url"
          >
        </div>
      </div>
    </div>

    <svg
      class="icon button-prev button"
      aria-hidden="true"
    >
      <use xlink:href="#icon-zuo"></use>
    </svg>

    <svg
      class="icon button-next button"
      aria-hidden="true"
    >
      <use xlink:href="#icon-you"></use>
    </svg>

    <svg
      class="icon button-thumbs-prev button"
      aria-hidden="true"
      v-show="list.length > 3"
    >
      <use xlink:href="#icon-zuoqiehuan"></use>
    </svg>

    <svg
      class="icon button-thumbs-next button"
      aria-hidden="true"
      v-show="list.length > 3"
    >
      <use xlink:href="#icon-youqiehuan"></use>
    </svg>
  </div>
</template>

<script>
import Vue from 'vue'

if (process.client) {
  const VueAwesomeSwiper = require('vue-awesome-swiper')
  Vue.use(VueAwesomeSwiper)
}

let vm = null

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: 0,
      isClick: false,
      isTransition: false,
      isThumbTransition: false,
      swiperOption: {
        threshold: 10,
        speed: 400,
        direction: 'horizontal',
        paginationClickable: true,
        loop: false,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
          disabledClass: 'button-disabled'
        },
        on: {
          slideChange: function () {
            if (vm.isClick) {
              return
            }

            if (vm.isThumbTransition) {
              return
            }

            console.log(this.activeIndex, vm.currentIndex, 'swiper')

            vm.isTransition = true

            vm.thumbs.slideTo(this.activeIndex, 400)
            vm.handleChangeSlide(this.activeIndex)

            vm.$nextTick(() => {
              vm.isTransition = false
            })
          }
        }
      },
      thumbsSwiperOption: {
        threshold: 10,
        speed: 400,
        paginationClickable: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        slidesPerRow: 3,
        spaceBetween: 7,
        preventClicksPropagation: true,
        navigation: {
          nextEl: '.button-thumbs-next',
          prevEl: '.button-thumbs-prev',
          disabledClass: 'button-disabled'
        },
        on: {
          slideChange: function () {
            if (vm.isClick) {
              return
            }

            if (vm.isTransition) {
              return
            }

            console.log(this.activeIndex, vm.currentIndex, 'thumb')

            vm.isThumbTransition = true

            vm.$swiper.slideTo(this.activeIndex, 400)
            vm.handleChangeSlide(this.activeIndex)

            vm.$nextTick(() => {
              vm.isThumbTransition = false
            })
          },
          click: function () {
            if (vm.isTransition) {
              return
            }

            if (vm.isThumbTransition) {
              return
            }

            console.log(this.clickedIndex, 'thumbClick', vm.isTransition)

            vm.isClick = true

            this.slideTo(this.clickedIndex, 400)
            vm.$swiper.slideTo(this.clickedIndex, 400)
            vm.handleChangeSlide(this.clickedIndex)

            vm.$nextTick(() => {
              vm.isClick = false
            })
          }
        }
      }
    }
  },

  created () {
    vm = this
  },

  methods: {
    handleChangeSlide (activeIndex) {
      this.currentIndex = activeIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  position: relative;
  width: 785px;

  .swiper-wrap {
    overflow: hidden;
    margin-bottom: 30px;
    width: 100%;
    height: 470px;
  }

  ::v-deep {
    .swiper-container {
      height: 100%;
    }

    #thumbs .swiper-slide {
      opacity: 0.5;
      filter: brightness(0.6);

      &.active {
        opacity: 1;
        filter: brightness(1);
      }
    }
  }

  .main-swiper {
    .banner-item {
      width: 785px;
      height: 470px;

      object-fit: cover;
    }
  }

  #thumbs {
    overflow: hidden;
    box-sizing: border-box;

    .banner-item {
      box-sizing: border-box;
      width: 256px;
      height: 156px;

      object-fit: cover;
    }
  }

  .button {
    position: absolute;
    top: 220px;
    z-index: 100;
    color: #5e5e5e;
    cursor: pointer;
  }

  .button-prev {
    left: 30px;
  }

  .button-next {
    right: 30px;
  }

  .button-thumbs-prev {
    top: 570px;
    left: -30px;
  }

  .button-thumbs-next {
    top: 570px;
    right: -30px;
  }

  .button-disabled {
    opacity: 0.3;
    cursor: default;
  }
}
</style>
